import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayVideo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 1.5,
		stroke: "currentColor",
		fill: "none",
		strokeLinejoin: "round",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M10.294,12l4.329,-2.5l-4.329,-2.5Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M19.889,3.389h-15.778c-0.614,0 -1.111,0.497 -1.111,1.111v10c0,0.614 0.497,1.111 1.111,1.111h15.778c0.614,0 1.111,-0.497 1.111,-1.111v-10c0,-0.614 -0.497,-1.111 -1.111,-1.111Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M8.56066,18.9393c0.585786,0.585786 0.585786,1.53553 0,2.12132c-0.585786,0.585786 -1.53553,0.585786 -2.12132,0c-0.585786,-0.585786 -0.585786,-1.53553 0,-2.12132c0.585786,-0.585786 1.53553,-0.585786 2.12132,0" }),
			/* @__PURE__ */ _jsx("path", { d: "M21,20h-12" }),
			/* @__PURE__ */ _jsx("path", { d: "M3,20h3" })
		]
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M0,0h24v24h-24Z"
	})]
});
export default SvgPlayVideo;
